import React from "react";
import style from "./AdminList.module.scss";

interface AdminListProps {
  /** Toolbar slot - pass <AdminListToolbar /> or a custom element. */
  toolbar?: React.ReactNode;
  /** Table, Pagination, and Modals go here as children. */
  children: React.ReactNode;
  className?: string;
}

/**
 * AdminList - shared page-shell for admin list screens.
 *
 * Provides the structural layout (toolbar row + table area) so individual admin
 * features own only their specific columns, search behaviour, and modals - not
 * the overall page grid. This is the long-term replacement for wiring features
 * through the monolithic `ListView` component.
 *
 * Usage:
 * ```tsx
 * <AdminList toolbar={<AdminListToolbar ... />}>
 *   <DataTableV2 ... />
 *   <Pagination ... />
 *   <MyFeatureModal ... />
 * </AdminList>
 * ```
 */
export const AdminList: React.FC<AdminListProps> = ({ toolbar, children, className }) => (
  <div className={`${style.root}${className ? ` ${className}` : ""}`}>
    {toolbar && <div>{toolbar}</div>}
    <div className={style.tableArea}>{children}</div>
  </div>
);
